import { Component, OnInit, OnDestroy } from '@angular/core';
import { GamesService } from '../Services/games.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';


@Component({
  selector: 'app-editgame',
  templateUrl: './editgame.component.html',
  styleUrls: ['./editgame.component.css']
})
export class EditgameComponent implements OnInit ,OnDestroy{

  myForm: FormGroup;
  disabled = false;
  ShowFilter = false;
  limitSelection = false;
  cities: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings: any = {};
  ngForm: FormGroup;
  countryNamed:any;

  thumb: File;
  thumb1: File;
  thumb2: File;
  poster: File;
  game_file: File;
  game_name: string;
  game_desc: string;
  name_ar: string;
  name_pr: string;
  desc_ar: string;
  desc_pr:string;
  user_id: string;
  game_cat: string;
  game_type: string;
  icon: string = 'fa fa-cloud-upload';
  game_id: string;
  game_object: any;
  game_thumb: any;
  game_thumb1: any;
  game_thumb2: any;
  game_poster: any;
  game_dev: string;
  game_tags: string;
  game_countries: Array<any> = ["null"]
  game_leader_array: string;
  game_leader_column: string;
  has_leader: boolean;
  cats = [];
  local1:any;
  local2:any;
  dropdownList = [];
  uniqueDropdown: any;





  constructor(private games: GamesService, private route: ActivatedRoute, private fb: FormBuilder) {
    this.user_id = localStorage.getItem('user_id');
    this.game_id = this.route.snapshot.params['id'];

    this.games.getGameData(this.game_id).subscribe(
      next => {
        this.game_object = next;
        console.log(this.game_object)
        this.game_name = this.game_object['game_name'];
        this.name_ar = this.game_object['name_ar'];
        this.name_pr = this.game_object['name_pr'];
        this.game_desc = this.game_object['game_desc'];
        this.desc_ar = this.game_object['desc_ar'];
        this.desc_pr = this.game_object['desc_pr'];
        this.game_thumb = this.game_object['game_thumb'];
        this.game_thumb1 = this.game_object['game_thumb1'];
        this.game_thumb2 = this.game_object['game_thumb2'];
        this.game_poster = this.game_object['game_photo'];
        this.game_type = this.game_object['game_type'];
        this.game_cat = this.game_object['game_cat'];
        this.game_tags = this.game_object['game_tags'].toString();


        this.game_countries = [JSON.stringify(this.game_object['game_countries'])]
        localStorage.setItem('game_countries',this.game_countries.toString())
        this.game_dev = this.game_object['game_dev'];
       console.log( this.game_countries + "this.game_countries" )  
      },
      error => { console.log(error) }
    )


  }


  ngOnInit() {
    this.getAllCats()
    this.cities = [
      { item_id: 'Nun' , item_text: 'Nun' },
      { item_id: 'egypt', item_text: 'egypt' },
      {  item_id: 'bahrain', item_text: 'bahrain' },
      { item_id: 'Bangalore', item_text: 'Bangalore' },
      { item_id: 'estonia', item_text: 'estonia' },
      {  item_id: 'iraq', item_text: 'iraq' },
      {  item_id: 'algeria', item_text: 'algeria' },
      {  item_id: 'kuwait', item_text: 'kuwait' },
      {  item_id: 'syria', item_text: 'syria' },
      {  item_id: 'united arab emirates', item_text: 'united arab emirates' },
      {  item_id: 'saudi arabia', item_text: 'saudi arabia' },
      {  item_id: 'india', item_text: 'india' },
      { item_id: 'yemen', item_text: 'yemen' },
      {  item_id: 'nepal', item_text: 'nepal' },
      { item_id: 'oman', item_text: 'oman' },
      {  item_id: 'sudan', item_text: 'sudan' },
      { item_id: 'senegal', item_text: 'senegal' },
      {  item_id:  'jordan', item_text: 'jordan' },
    ];

    this.local1 = localStorage.getItem('game_countries');
    this.local2 =  JSON.parse(this.local1);
    this.selectedItems = this.local2

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter
    };
    this.myForm = this.fb.group({
      city: [this.selectedItems]

    });
    console.log(this.game_countries)
    // if(localStorage.getItem('x')=='1'){localStorage.setItem('x','0')}
    // else{localStorage.setItem('x','1'); setTimeout(()=>{location.reload(),5000})}

  }



  /**
   * @description select country games will not show
   */


  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 6 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }


  onItemSelect(item: any) {
    this.countryNamed =  this.myForm.controls['city'].value
  }
  onSelectAll(items: any) {
   this.countryNamed =  this.myForm.controls['city'].value
  }
  
  /**
  * @description get all games cats 
  */
  getAllCats() {
    this.games.getAllCats().subscribe(next => {
      this.cats = next['cat_lists'];
      console.log(next['cat_lists']);
    }, error => { console.log(error) });
  }

  //get the game thumb
  getThumb(inputfile) {
    if (inputfile.target.files && inputfile.target.files[0]) {
      this.thumb = inputfile.target.files[0];


      // var _URL = window.URL;
      // var img = new Image( );
      //  var imgwidth = 0;
      //  var imgheight = 0;
      //  var maxwidth = 640;
      //  var maxheight = 640;
      //  img.src = _URL.createObjectURL(this.thumb.webkitRelativePath);
      //  imgwidth = img.width;
      //  imgheight = img.height;
      //  img.onload = function() {


      //  }
      //  //console
      //  if(imgwidth<1900){
      //    console.log('width ecess',img.width);
      //  }
      //  else {
      //    console.log('higigigi');
      //  }

      console.log(this.thumb);
    }
  }

  getThumb1(inputfile) {
    if (inputfile.target.files && inputfile.target.files[0]) {
      this.thumb1 = inputfile.target.files[0];
      console.log(this.thumb1);
    }
  }
  getThumb2(inputfile) {
    if (inputfile.target.files && inputfile.target.files[0]) {
      this.thumb2 = inputfile.target.files[0];
      console.log(this.thumb2);
    }
  }
  

  getPoster(inputfile) {

    if (inputfile.target.files && inputfile.target.files[0]) {
      this.poster = inputfile.target.files[0];


      // var _URL = window.URL;
      // var img = new Image( );
      //  var imgwidth = 0;
      //  var imgheight = 0;
      //  var maxwidth = 640;
      //  var maxheight = 640;
      //  img.src = _URL.createObjectURL(this.thumb.webkitRelativePath);
      //  imgwidth = img.width;
      //  imgheight = img.height;
      //  img.onload = function() {


      //  }
      //  //console
      //  if(imgwidth<1900){
      //    console.log('width ecess',img.width);
      //  }
      //  else {
      //    console.log('higigigi');
      //  }
      console.log(this.poster);
    }
  }

 

  //get the game file
  getGame(inputfile) {

    if (inputfile.target.files && inputfile.target.files[0]) {
      this.game_file = inputfile.target.files[0];
      console.log(this.game_file);
    }
  }
  //addgame 

  uploadeGame() {
    
     //debugger
    this.countryNamed =  this.myForm.controls['city'].value
    const countryNamedObj = this.countryNamed.map(a => a.item_text);

    //create post form
    var data = new FormData();
    data.append('game_name', this.game_name);
    data.append('name_ar', this.name_ar);
    data.append('name_pr', this.name_pr);
    data.append('game_desc', this.game_desc);
    data.append('desc_ar', this.desc_ar);
    data.append('desc_pr', this.desc_pr);
    data.append('game_thumb', this.thumb);
    data.append('game_thumb1', this.thumb1);
    data.append('game_thumb2', this.thumb2);
    data.append('game_poster', this.poster);
    data.append('game_file', this.game_file);
    data.append('user_id', this.user_id);
    data.append('game_cat', this.game_cat);
    data.append('game_type', this.game_type);
    data.append('game_id', this.game_id);
    data.append('game_dev', this.game_dev);
    data.append('game_tags', this.game_tags);
    data.append('game_countries',countryNamedObj);
   

    data.append('game_leader_array', this.game_leader_array);
    data.append('game_leader_column', this.game_leader_column);

console.log(this.countryNamed,"this.countryNamed")
    this.games.editGame(data).subscribe(
      next => { console.log(next) },
      error => { console.log(error) },
      () => {
        this.icon = 'glyphicon glyphicon-ok';

      }
    )

    localStorage.setItem('game_countries', null)

  }
  uploadeIcon(fa) {
    this.icon = fa;
  }

  hasleader($ev) {
    if ($ev.target.checked) {
      this.has_leader = true;
    }
    else {
      this.has_leader = false;
    }
  }

ngOnDestroy(){
  localStorage.setItem('game_countries','')
}

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/editgame/editgame.component.ts